import type { Dispatch, SetStateAction } from "react";
import { useEffect, useState } from "react";
import type * as type from "@vTypes";

function ConfSection_default({
  curWardName,
  show_level,
  show_preceptor,
  setCurrentConfigures,
}: {
  curWardName: string;
  show_level: boolean;
  show_preceptor: boolean;
  setCurrentConfigures: Dispatch<SetStateAction<type.ConfigObject>>;
}) {
  /* 병동이름설정 임시 */
  const [groupName, setGroupName] = useState<string>(curWardName);

  useEffect(() => {
    setGroupName(curWardName);
  }, [curWardName]);

  return (
    <div className="conf_schedule__itemWrap w-[320px] max-w-[320px]">
      <h2 className="conf_schedule__title">기본 설정</h2>
      <div className="conf_schedule__table">
        <div className="conf_schedule__row conf_schedule__gridRow--switch2">
          <div className="conf_schedule__optText conf_schedule__numInputWrap">
            부서 이름
          </div>

          <div className="conf_schedule__numInput">
            {groupName}
            {/* <input
              type="text"
              style={{ width: "100%" }}
              value={groupName}
              disabled={true}
              onInput={(e) => {
                const changeValue = e.currentTarget.value;
                setGroupName(changeValue);
              }}
            /> */}
          </div>
        </div>

        <div className="conf_schedule__row conf_schedule__gridRow--switch2">
          <div className="conf_schedule__optText">직책 표시</div>
          <label className="conf_slideSwitch">
            <input
              type="checkbox"
              checked={show_level}
              onChange={(e) => {
                setCurrentConfigures((prev) => ({
                  ...prev,
                  show_level: e.target.checked,
                }));
              }}
            />
            <span className="conf_switchHandler"></span>
            <span className="conf_switchStatus">근무표에 적용</span>
          </label>
        </div>

        <div className="conf_schedule__row conf_schedule__gridRow--switch2">
          <div className="conf_schedule__optText">프리셉터 표시</div>
          <label className="conf_slideSwitch">
            <input
              type="checkbox"
              checked={show_preceptor}
              onChange={(e) => {
                setCurrentConfigures((prev) => ({
                  ...prev,
                  show_preceptor: e.target.checked,
                }));
              }}
            />
            <span className="conf_switchHandler"></span>
            <span className="conf_switchStatus">근무표에 적용</span>
          </label>
        </div>
      </div>
    </div>
  );
}

export default ConfSection_default;
